import {API_URL} from "../config";
import axios from "../utils/axios";

class ParkingZoneRepository
{
    save(data) {
        return axios.post(API_URL + "/ParkingZone/Save", data);
    }

    getAll(filter) {
        return axios.get(API_URL + "/ParkingZone/List?", {params: filter});
    }

    getById(id) {
        return axios.get(API_URL + `/ParkingZone/${id}`);
    }

    delete(id) {
        return axios.delete(API_URL + `/ParkingZone/${id}`);
    }

    getSelector() {
        return axios.get(API_URL + `/ParkingZone/Selector`);
    }
}

export default ParkingZoneRepository;